import type { IconData } from '@stacksjs/iconify-core'

export const be1x1: IconData = {
  "body": "<g fill-rule=\"evenodd\" stroke-width=\"1pt\"><path fill=\"#000001\" d=\"M0 0h170.7v512H0z\"/><path fill=\"#ffd90c\" d=\"M170.7 0h170.6v512H170.7z\"/><path fill=\"#f31830\" d=\"M341.3 0H512v512H341.3z\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default be1x1
